import { Dialog, DialogSurface, DialogBody, DialogTitle, Button, DialogContent, DialogActions } from "@fluentui/react-components";
import { Dismiss24Filled } from "@fluentui/react-icons";
import React from "react";
import { S365Button } from "../../components/s365-button/s365-button.component";
import { RegistrationConfirmationPostModel, UserResponseModel } from "../../swagger-clients/s365-dashboard-v2-api-clients.service";
import { processServerError } from "../../utils/helpers/error.helper";
import { getUsersClient } from "../../services/dashboard.service";
import { toast } from "react-toastify";

type ConfirmEmailDialogProps = {
    user: UserResponseModel;
    isOpened?: boolean;
}

export const ConfirmEmailDialog: React.FC<ConfirmEmailDialogProps> = (props) => {
    const [open, setOpen] = React.useState(false);

    React.useEffect(() => {
        setOpen(!!props.isOpened);
    }, [props.isOpened]);



    const resendConfirmationLink = async () => {
        try {
            const client= getUsersClient();
            const model= new RegistrationConfirmationPostModel({email:props.user.email});
            await client.resendEmailConfirmation(model);
            toast.success("A confirmation email has been sent successfully.");

        } catch (error) {
            processServerError(error, undefined, "An error occurred while resending confirmation email.");
        }
    }


    return <Dialog open={open} onOpenChange={(event, data) => {
        event.preventDefault();
    }}>
        <DialogSurface>

            <DialogBody>
                <DialogContent>
                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                        <h3 style={{ textAlign: "center" }}>To continue, confirm your email address<br />with the link we sent you.</h3>
                        <S365Button onClick={resendConfirmationLink}>Resend confirmation email</S365Button>
                    </div>
                </DialogContent>
            </DialogBody>
        </DialogSurface>
    </Dialog>
}